import type { IconData } from '@stacksjs/iconify-core'

export const folderOpenF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 5V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2H17a3 3 0 0 1 3 3zm0 2h20v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default folderOpenF
